import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ViewPage as ViewPageCommon } from '@atlassian/embedded-confluence-common';
import { AnalyticsListener } from '../analytics';
import { useIntl } from 'react-intl-next';
var ViewPage = function ViewPage(props) {
  var embeddedConfluenceSource = props.embeddedConfluenceSource,
    hostname = props.hostname,
    parentProduct = props.parentProduct,
    userInfo = props.userInfo;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  return /*#__PURE__*/React.createElement(AnalyticsListener, {
    embeddedConfluenceSource: embeddedConfluenceSource,
    hostname: hostname,
    parentProduct: parentProduct,
    userInfo: userInfo
  }, /*#__PURE__*/React.createElement(ViewPageCommon, _extends({
    locale: locale
  }, props)));
};
export default ViewPage;